var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 62,
    viewBox: "0 0 91 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 12.5817 3.58172 9 8 9H81.5H90.5V52.5H81.5H8C3.58172 52.5 0 48.9183 0 44.5V17Z",
    fill: "#ED0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 9L81.5 0V9H90.5Z",
    fill: "#B40000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 61.5L90.5 52.5H81.5V61.5Z",
    fill: "#B40000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOffer);
export default __webpack_public_path__ + "static/media/card-offer.5ecd08e02dbdec2502e2d84ecfdc69f8.svg";
export { ForwardRef as ReactComponent };